import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, keywords, canonical, schema }) => {
  const defaultTitle = "Excellent Motors - Authorized Yamaha Bike and Scooter Dealer in Delhi";
  const defaultDescription = "Excellent Motors - Authorized Yamaha Dealer. Enjoy great offers on FZ, R15, MT-15, RayZR, and Fascino with low down-payment schemes.";
  
  // High-value localized Delhi SEO keywords requested for maximum search presence
  const globalKeywords = [
    "yamaha showroom near me",
    "yamaha showroom Pitampura",
    "yamaha showroom Rohini",
    "yamaha showroom Saraswati Vihar",
    "yamaha showroom Peeragarhi",
     "yamaha showroom Shalimar Bagh",
    "yamaha showroom uttam nagar",
    "yamaha showroom delhi",
    "yamaha showroom dwarka",
    "yamaha showroom rajapuri",
    "yamaha showroom nangloi",
    "yamaha showroom in delhi",
    "near yamaha showroom",
    "yamaha showroom najafgarh",
    "najafgarh yamaha showroom",
    "azadpur yamaha showroom",
    "yamaha showroom",
    "showroom yamaha",
    "yamaha motors near me",
    "yamaha showroom karol bagh",
    "yamaha showroom Azadpur",
    "yamaha showroom Patel nagar",
    "yamaha showroom wazirpur",
    "yamaha showroom Nangloi",
    "yamaha showroom rani bagh",
    "yamaha showroom tilak nagar",
    "yamaha showroom Rajouri garden",
    "yamaha showroom Moti nagar",
    "yamaha showroom Inderlok",
    "yamaha showroom Ramesh nagar",
    "yamaha showroom Mangolpuri",
    "yamaha showroom Janakpuri",
    "yamaha showroom Janak puri",
    "yamaha showroom Narela",
    "yamaha showroom Burari",
    "yamaha showroom Ashok Vihar",
  ];

  // Safely merge, clean, and deduplicate page-specific keys with global keywords
  const pageKeys = keywords ? keywords.split(",").map(k => k.trim()) : [];
  const mergedKeys = Array.from(new Set([...pageKeys, ...globalKeywords]));
  const finalKeywords = mergedKeys.join(", ");

  return (
    <Helmet>
      {/* General Meta Tags */}
      <title>{title ? `${title} | Excellent Yamaha` : defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={finalKeywords} />
      <meta name="author" content="Excellent Motors" />
      <link rel="canonical" href={canonical || "https://excellentmotors.in"} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title ? `${title} | Excellent Yamaha` : defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:url" content={canonical || "https://excellentmotors.in"} />
      <meta property="og:image" content="https://excellentmotors.in/favicon.png" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title ? `${title} | Excellent Yamaha` : defaultTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content="https://excellentmotors.in/favicon.png" />

      {/* Structured Data (Schema.org / JSON-LD) */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
